<template>
  <div class="loading-veridas-container">
    <progress-bar :percentage="percentage" v-if="time > 0" />
    <div class="container w100 relative-container">
      <div class="padded">
        <wrap-container v-if="time === 0">
          <step-icon>
            <img src="../assets/img/1x/target.svg" alt="Ícono cargando..." />
          </step-icon>
          <p class="titulo p28 oscuro medium">
            Ya casi finaliza tu validación...
          </p>
          <p class="subtitulo oscuro">
            Aguardá unos segundos más hasta completar la validación de tus datos
          </p>
        </wrap-container>
        <wrap-container v-else>
          <p class="titulo p28 oscuro medium">Estamos validando tus fotos</p>
          <p class="subtitulo oscuro">
            Procesar todas tus fotos puede tardar hasta 30 segundos.
          </p>
          <step-loader class="step-loader" :percentage="percentage">
            <step-icon text="Validando el frente de tu DNI...">
              <img src="../assets/img/1x/dni-frente.svg" alt="Frente DNI" />
            </step-icon>
            <step-icon text="Validando el dorso de tu DNI...">
              <img src="../assets/img/1x/dni-dorso.svg" alt="Dorso DNI" />
            </step-icon>
            <step-icon text="Validando tu selfie...">
              <img src="../assets/img/1x/biometric_dark.svg" alt="Biometría" />
            </step-icon>
            <step-icon text="Validando tu video selfie...">
              <img
                src="../assets/img/1x/mobile_access_biometric.svg"
                alt="Celular biometría"
              />
            </step-icon>
          </step-loader>
        </wrap-container>
      </div>
    </div>
    <div class="loading-veridas-footer">
      <div class="padded">
        <p v-if="time === 0">¡Estás más cerca de tu {{ nombreProducto }}!</p>
        <p v-else>
          Por la seguridad de tus datos es importante realizar este proceso de
          validación.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ProgressBar from "@/components/core/ProgressBar.vue";
import StepLoader from "@/components/core/custom/StepLoader.vue";
import StepIcon from "@/components/core/StepIcon.vue";
import { nombreCircuito } from "../config/constants";

export default {
  name: "LoadingVeridas",
  components: {
    WrapContainer,
    ProgressBar,
    StepLoader,
    StepIcon
  },
  data() {
    return {
      maxTime: 30,
      time: -1,
      watcher: null,
      nombreProducto: nombreCircuito[this.$store.getters.getConsulta().circuito]
    };
  },
  mounted() {
    // Tiempo a esperar
    this.time = this.maxTime;
    this.watcher = this.$store.watch(
      this.$store.getters.getErrorVeridas,
      error => {
        console.log("error", error);
        if (error) {
          // Si ocurrió algún error con la validación
          // redirigimos a la pantalla de error luego de 1 segundo
          setTimeout(() => {
            if (error === "continua-sucursal") {
              this.$router.push({ name: "continuaSucursal" });
            } else {
              this.$router.push({
                name: "mensajeVeridas",
                params: {
                  mje: error
                }
              });
            }
          }, 1000);
        }
      },
      { immediate: true }
    );
  },
  destroyed() {
    if (this.watcher) {
      this.watcher();
    }
  },
  computed: {
    percentage() {
      return 100 - (this.time * 100) / this.maxTime;
    }
  },
  watch: {
    time: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.time--;
          }, 1000);
        }
      },
      inmediate: true
    }
  }
};
</script>

<style scoped>
.loading-veridas-container {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.loading-veridas-container > .container {
  flex: 1;
  padding-top: 30px;
}
.loading-veridas-footer {
  background-color: #f4f4f4;
}
.loading-veridas-footer p {
  color: #121212;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4em;
}

p {
  text-align: center;
  margin-left: 40px;
  margin-right: 40px;
}
.subtitulo {
  font-size: 16px;
  line-height: 1.4em;
}

.step-loader {
  margin: 50px -17px;
  width: auto;
}
</style>
